<template>
      <div>
        <v-card elevation="0">
          <plotly
            ref="graph"
            :data="graph_data['data_render']"
            :layout="graph_data['layout_render']"
            :displayModeBar="true"
          />
        </v-card>
      </div>
</template>

<script>

import { Plotly } from "vue-plotly";


export default {
    components: {
      Plotly,
    },

    props: {
        graph_data: {
            type: Object,
            required: true
        },
        dates: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
        }
    },

    watch: {
      graph_data: {
        handler() {
          // console.log('handling')
        },
        deep: true,
      }
    },
}
</script>

<style>
    #bar-chart{
        cursor: pointer;
    }
</style>